export enum ExamActionsEnum {
    FetchStartRemindo = '[exam] fetchStartRemindo',
    FetchStartRemindoSuccess = '[exam] fetchStartRemindoSuccess',
    UnsetExam = '[exam] unsetExam',
}
